import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useCallback, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { useIngredientStocks, useIngredientTypes } from 'redux/hooks/IngredientDetail';
import { removeTypes } from 'redux/reducers/ingredientDetailReducer';
import { IStyle } from 'Styles';
import AddIngredientTypes from './AddIngredientTypes';
import RMModal from 'components/modal/RMModal';
import RMCustomButton, {
  RMCustomButtonProps,
} from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';

const TYPES_COLUMNS = [{ accessor: 'name', Header: 'Ingredient Type' }];

const Types = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const types = useIngredientTypes();
  const stocks = useIngredientStocks();
  const dispatch = useRMDispatch();
  const [error, setError] = useState({ show: false, msg: '' });

  const handleSelectionChange = (rowIndices) => {
    setSelectedRows([...rowIndices]);
  };

  const handleDeleteTypes = useCallback(() => {
    const typesToDelete = selectedRows.map((i) => {
      return types[i];
    });
    const bufferTypes = typesToDelete.filter((t) => t.isBuffer);
    const nonBufferTypes = typesToDelete.filter((t) => !t.isBuffer);
    const filteredTypes = [...types].filter(
      (t) => !typesToDelete.find((type) => type.id === t.id),
    );
    if (
      bufferTypes.length &&
      !filteredTypes.find((t) => t.isBuffer) &&
      stocks.find((s) => s.isBuffer)
    ) {
      setError({
        show: true,
        msg: 'Buffer types cannot be deleted as there are some stocks that are marked as buffer. First mark all buffer stocks as non-buffer stocks.',
      });
    } else if (
      nonBufferTypes.length &&
      !filteredTypes.find((t) => !t.isBuffer) &&
      stocks.find((s) => !s.isBuffer)
    ) {
      setError({
        show: true,
        msg: 'Non-buffer types cannot be deleted as there are some stocks that are marked as non-buffer. First mark all non-buffer stocks as buffer stocks.',
      });
    } else {
      dispatch(removeTypes(typesToDelete));
      setSelectedRows([]);
    }
  }, [selectedRows, types, stocks, dispatch]);

  const hideModal = () => {
    setError({ ...error, show: false });
  };

  const deleteIngredientTypesIcon: RMCustomButtonProps = {
    Icon: (
      <RMSvgIcon id='types-deling-icon' subfolder="Setup" name="Remove" className="w-8 h-8 cursor-pointer" />
    ),
    titleTip: 'Delete Ingredient Types',
    onClick: handleDeleteTypes,
  };

  return (
    <div
      id="typesingeredient-main-container"
      className="flex basis-full flex-col max-h-full dashed-border"
    >
      <div id="typesingredient-title" className="basis-1/12 p-2 font-bold">
        Types
      </div>
      <div id="typesingredient-table" className="basis-8/12 flex max-h-[14vh]">
        <RMTable
          data={[...types]}
          columns={TYPES_COLUMNS}
          selectedIds={selectedRows}
          onCheckboxSelectionChange={handleSelectionChange}
          mainContainerStyle={styles.tableStyle}
          cellClassName="justify-start"
        />
      </div>
      <div
        id="typesingredient-buttons-wrapper"
        className="basis-3/12 flex gap-2 px-2 items-end pb-1"
      >
        <AddIngredientTypes />
        <RMCustomButton {...deleteIngredientTypesIcon} />
      </div>
      <RMModal
        id="typesingredient-modal-warning"
        setShowModal={(e) => setError({ ...error, show: e })}
        showModal={error.show}
        onOk={hideModal}
        isOkOnly
        heading="Warning"
        body={error.msg}
        okButtonText="Ok, Close"
      />
    </div>
  );
};

const styles: IStyle = {
  tableStyle: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
};

export default Types;
